import NotFound from '@/frame/404.vue'
import Login from '@/frame/Login.vue'
import SSO from '@/frame/sso.vue'
import MainLayout from '@/frame/main/MainLayout.vue'
import EmptyLayout from '@/micro-app/component/EmptyLayout.vue'
import Vue from 'vue'
import Router from 'vue-router'
import {
  microRoute
} from '@/micro-app/port-config'; // 子应用路由
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}

Vue.use(Router)

let routes = [{
  path: '/login',
  component: Login,
  name: '',
  hidden: true
}, {
  path: '/404',
  component: NotFound,
  name: '',
  hidden: true
}, {
  path: '/',
  hidden: true,
  redirect: {
    path: '/login'
  }
}, {
  path: '/sso',
  hidden: true,
  component: SSO,
},{
  path: '/adminLogin',
  hidden: true,
  component: Login,
}, {
  path: '*',
  hidden: true,
  redirect: {
    path: '/404'
  }
}, {
  path: "/main",
  component: MainLayout,
  redirect: "/main/desktop",
  name: "desktop",
  children: [{
    path: "desktop",
    name: "首页",
    component: () => import('@/pages/desktop.vue')
  }]
}, {
  path: "/emptyLayout",
  component: EmptyLayout,
  name: "EmptyLayout",
  children: []
}]

let index = routes.findIndex(item => item.path === "/main")
routes[index].children = routes[index].children.concat(microRoute())

let indexEmptry = routes.findIndex(item => item.path === "/emptyLayout")
routes[indexEmptry].children = routes[indexEmptry].children.concat(microRoute())

// console.log(routes, '---');

export default new Router({
  mode: 'history',
  routes: routes
})



// WEBPACK FOOTER //
// ./src/router/index.js